import React from "react";
import { Plus, Trash2 } from "lucide-react";

/**
 * Key-column pairs (exact match / tolerance / date partition keys).
 * Props: rule, index, onChange, listKey (match_keys | tolerance_keys | date_keys | ...),
 *        label, testidPrefix, minOne (don't allow removing last row), addLabel
 */
export default function MatchKeysBlock({ rule, index, onChange, listKey, label, testidPrefix, minOne = false, addLabel = "Add pair" }) {
  const items = rule[listKey] || [];
  const update = (ki, field, value) => {
    const next = [...items];
    next[ki] = { ...next[ki], [field]: value };
    onChange({ ...rule, [listKey]: next });
  };
  const add = () => onChange({ ...rule, [listKey]: [...items, { file_a_col: "", file_b_col: "" }] });
  const remove = (ki) => onChange({ ...rule, [listKey]: items.filter((_, i) => i !== ki) });
  return (
    <div style={{ marginBottom: "1rem" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        <p style={{ fontSize: "0.78rem", fontWeight: 600, color: "var(--text-secondary)", margin: 0, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</p>
        <button data-testid={`${testidPrefix}-add-${index}`} onClick={add} style={{ display: "flex", alignItems: "center", gap: "0.25rem", fontSize: "0.75rem", color: "var(--sage)", background: "none", border: "none", cursor: "pointer" }}>
          <Plus size={12} /> {addLabel}
        </button>
      </div>
      {items.map((mk, ki) => (
        <div key={ki} style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: "0.5rem", marginBottom: "0.375rem" }}>
          <input data-testid={`${testidPrefix}-a-${index}-${ki}`} className="recon-input" value={mk.file_a_col || ""} onChange={e => update(ki, "file_a_col", e.target.value)} placeholder="File A col" style={{ fontSize: "0.8rem", fontFamily: "JetBrains Mono, monospace" }} />
          <input data-testid={`${testidPrefix}-b-${index}-${ki}`} className="recon-input" value={mk.file_b_col || ""} onChange={e => update(ki, "file_b_col", e.target.value)} placeholder="File B col" style={{ fontSize: "0.8rem", fontFamily: "JetBrains Mono, monospace" }} />
          <button onClick={() => remove(ki)} disabled={minOne && items.length === 1}
            style={{ background: "none", border: "none", cursor: "pointer", color: "#DC2626", opacity: (minOne && items.length === 1) ? 0.3 : 1 }}>
            <Trash2 size={12} />
          </button>
        </div>
      ))}
    </div>
  );
}
